import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { captureAttributionInBrowser } from "@/lib/attribution";
import { contactChannelFromHref, trackContactClick } from "@/lib/analytics";
import { AnimatePresence } from "framer-motion";
import Header from "@/components/landing/Header";
import Footer from "@/components/landing/Footer";
import CookieConsent from "@/components/CookieConsent";
import DelayedLeadPopup from "@/components/DelayedLeadPopup";

import PageTransition from "@/components/PageTransition";
import { TransformFormProvider } from "@/components/onboarding/TransformFormContext";
import { VisitFormProvider } from "@/components/onboarding/VisitFormContext";
import { PartnerFormProvider } from "@/components/onboarding/PartnerFormContext";
import { ContactFormProvider } from "@/components/onboarding/ContactFormContext";
import { DossierGateProvider } from "@/components/onboarding/DossierGate";

const Layout = () => {
  const location = useLocation();

  // First-touch attribution (sessionStorage) + contact-link clicks (WhatsApp / email / phone).
  useEffect(() => {
    captureAttributionInBrowser();
    const onClick = (e: MouseEvent) => {
      const a = (e.target as Element | null)?.closest?.("a[href]") as HTMLAnchorElement | null;
      if (!a) return;
      const channel = contactChannelFromHref(a.getAttribute("href") || "");
      if (channel) trackContactClick(channel, window.location.pathname);
    };
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);

  return (
    <TransformFormProvider>
      <VisitFormProvider>
      <PartnerFormProvider>
      <ContactFormProvider>
      <DossierGateProvider>
      <div className="min-h-screen bg-background">
        <Header />
        <AnimatePresence mode="wait">
          <PageTransition key={location.pathname}>
            <main>
              <Outlet />
            </main>

          </PageTransition>
        </AnimatePresence>
        <Footer />
        <CookieConsent />
        <DelayedLeadPopup />
      </div>
      </DossierGateProvider>
      </ContactFormProvider>
      </PartnerFormProvider>
      </VisitFormProvider>
    </TransformFormProvider>
  );
};

export default Layout;

